import { render, staticRenderFns } from "./Pass_control.vue?vue&type=template&id=09c64d33&scoped=true"
import script from "./Pass_control.vue?vue&type=script&lang=js"
export * from "./Pass_control.vue?vue&type=script&lang=js"
import style0 from "./Pass_control.vue?vue&type=style&index=0&id=09c64d33&prod&lng=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c64d33",
  null
  
)

export default component.exports